import { Button, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"

interface ConfirmationProps {
    message: string
    show: boolean
    onHide: () => void
    onConfirm: () => void
}

function Confirmation(props: ConfirmationProps) {
    const { t } = useTranslation("global")

    return (
        <Modal show={props.show} onHide={props.onHide} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{t("confirmation.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <b>{props.message}</b>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.onHide}>{t("confirmation.no")}</Button>
                <Button variant="danger" onClick={() => props.onConfirm()}>{t("confirmation.yes")}</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default Confirmation